import { Box } from '@mui/material';
import React, { PropsWithChildren } from 'react';

import { Divider } from '../Divider/Divider';
import { Typography } from '../Typography/Typography';

export interface MenuLinkListProps {
  headline?: string;
}

export const MenuLinkList: React.FC<PropsWithChildren<MenuLinkListProps>> = ({ children, headline }) => {
  return (
    <Box minWidth="268px">
      {headline && (
        <>
          <Typography
            component="div"
            variant="button"
            fontWeight={{ md: 'bold' }}
            color="primary"
            sx={{ py: { xs: 5, md: 4 } }}
            innerPadding="horizontal"
          >
            {headline}
          </Typography>
          <Divider sx={{ pb: { md: 4 } }} />
        </>
      )}
      {React.Children.map(children, (child) => {
        return React.isValidElement(child) ? (
          <React.Fragment key={child.key}>
            {child}
            <Divider sx={{ display: { md: 'none' } }} />
          </React.Fragment>
        ) : null;
      })}
    </Box>
  );
};
